import Dexie from "dexie";

interface VideoChunk {
  id?: number;
  order: number;
  from: number;
  to: number;
  blob: Blob;
}

interface VideoMeta {
  id?: number;
  url: string;
  chunkCount: number;
  chunkSize: number;
}

export class VideoChunkDatabase extends Dexie {
  videoChunks?: Dexie.Table<VideoChunk, number>;
  meta?: Dexie.Table<VideoMeta, number>;

  constructor(dbName: string, version = 1) {
    super(dbName);
    this.version(version).stores({
      videoChunks: "++id,from, end, order, blob",
      meta: "++id,url,chunkCount,chunkSize"
    });
  }
}

export interface Chunk {
  blob: Blob;
  order: number;
  to: number;
  from: number;
}

export interface ImageChunks {
  url: string;
  eTag: string;
  chunkCount: number;
  chunkSize: number;
  chunks: Chunk[];
}

export class ImageSequenceDatabase extends Dexie {
  private imageSequence!: Dexie.Table<ImageChunks, string>;

  constructor(version = 1) {
    super("dex-image-sequence");
    this.version(version).stores({
      // & Unique index
      imageSequence: "&url, etag, chunks"
    });
  }

  async put(chunks: ImageChunks): Promise<void> {
    await this.imageSequence.put(chunks);
  }

  async get(url: string): Promise<ImageChunks | undefined> {
    // Oveření, že se jedná o validní URL
    const urlObj = new URL(url);
    return await this.imageSequence.get(urlObj.href);
  }

  getAll(): Promise<ImageChunks[]> {
    return this.imageSequence.toArray();
  }

  remove(url: string): Promise<void> {
    return this.imageSequence.delete(url);
  }

  clear(): Promise<void> {
    return this.imageSequence.clear();
  }
}
